<template>
  <div
    v-if="nextElement.id"
    class="c-switch-element"
  >
    <ui-popover center>
      <template #wrapper>
        <i
          v-accessibility-focus="playNextElement"
          class="o-icon o-icon--next"
          :aria-label="$t('accessibility.player.nextEpisode')"
        ></i>
      </template>
      <template #content>
        <div class="c-switch-element__content">
          <img
            :src="img"
            :alt="nextElement.title"
          >
          <p class="o-typography__title2 u-text-center u-ellipsis">
            {{ title }}
          </p>
        </div>
      </template>
    </ui-popover>
  </div>
</template>
<script>
  import UiPopover from '@/shared/components/popover/index.vue';
  import { NextElementMixin, NextEpisodeMixin, NextRelatedProductMixin } from '@/shared/components/player/mixins';
  import { ProductType } from '@/shared/enums';
  import meta from '@/index/shared/filters/meta';
  import { getLogo } from '@/shared/utils';

  export default {
    name: 'UiPlayerNextElement',
    components: { UiPopover },
    mixins: [
      NextElementMixin,
      NextEpisodeMixin,
      NextRelatedProductMixin,
    ],
    computed: {
      img() {
        return getLogo(this.nextElement);
      },
      title() {
        const { type, title } = this.nextElement;

        if (type === ProductType.EPISODE) {
          return `${meta(this.nextElement, 'seasonAndEpisode')}: ${title}`;
        }

        return title;
      },
    },
  };
</script>
